import type { OptimizelyVariation } from '@optimizely/optimizely-sdk/dist/shared_types';
import { useCallback, useMemo } from 'react';
import { Button, Stack } from '@customink/pigment-react';
import { useDecision, useOptimizely } from '~/contexts/OptimizelyContext';

interface VariationsProps {
    variations?: { [variationKey: string]: OptimizelyVariation };
    featureKey: string;
}

export function Variations({ variations, featureKey }: VariationsProps) {
    const [decision] = useDecision(featureKey);
    const variationOptions = useMemo(
        () => Object.keys(variations ?? {}).sort((a, b) => -1 * a.localeCompare(b)), // Z-A
        [variations],
    );
    const { setForcedFeatureFlag } = useOptimizely();

    const setFeatureFlag = useCallback(
        (variationKey: string) => {
            setForcedFeatureFlag(featureKey, variationKey);
        },
        [featureKey],
    );

    return (
        <Stack spacing={2} direction="row">
            {variationOptions.map((variant) => (
                <Button
                    variant={decision.variationKey === variant ? 'primary' : 'secondary'}
                    key={variant}
                    onClick={() => setFeatureFlag(variant)}
                >
                    {variant}
                </Button>
            ))}
        </Stack>
    );
}
